export const COLORS = {
  // Theme and brand colors
  THEME_PRIMARY: "#e01e51",
  THEME_SECONDARY: "#a9a9a9",
  THEME_ACCENT: "#009e83",
  PRIMARY: "#f11c3a",
  PRIMARY_HOVER: "#ff3650",
  PRIMARY_SUBTLE: "rgba(241, 28, 58, 0.1)",
  DANGER: "red",
  DANGER_BORDER: "rgb(211, 47, 47)",

  // Text and icons
  TEXT_PRIMARY: "#191c23",
  TEXT_SECONDARY: "#5f5f5f",
  TEXT_MUTED: "#aaa",
  TEXT_DISABLED: "#999",
  TEXT_DARK_MUTED: "#5d3f3f",
  TEXT_BLACK: "#000",
  TEXT_WHITE: "#fff",
  TEXT_MEDIUM_EMPHASIS: "rgba(0, 0, 0, 0.6)",
  TEXT_HIGH_EMPHASIS: "rgba(0, 0, 0, 0.8)",

  // Surfaces, borders, and interaction states
  TRANSPARENT: "transparent",
  SURFACE_PAGE: "#f7f8fa",
  SURFACE_CHART: "#f5f5f5",
  SURFACE_SELECTED: "#e0e1e3",
  SURFACE_HOVER: "rgba(0, 0, 0, 0.04)",
  SURFACE_HIGHLIGHT: "rgba(200, 200, 200, 0.2)",
  SURFACE_ACCENT_ROW: "#009e8350",
  SURFACE_ACCENT_ROW_HOVER: "#009e8330",
  BORDER: "#e2e7ee",
  ROW_BORDER: "rgb(224, 224, 224)",
  BORDER_MEDIUM: "#c1c1c1",
  BORDER_CONTROL: "#bbb",
  BORDER_SUBTLE: "#ddd",
  BUTTON_SECONDARY: "#888",
  DROP_SHADOW: "rgba(0, 0, 0, 0.32)",

  // Feature-specific colors
  UPLOAD_ACTIVE: "#018273",
  UPLOAD_IDLE: "#90a4ae",
  CHART_NEUTRAL: "#6e6e6e",
  CHART_ALERT: "#ff0000",
  CHART_BORDER: "#646464",
  EXPORT_SERIES_PRIMARY: "rgb(221, 93, 127)",
  EXPORT_SERIES_SECONDARY: "rgb(149, 213, 200)",

  DEFAULT_CHART_LABEL_COLOR: "#3a4f5f",
  CHART_BASIC: ["#97ccf5", "#bbd5e2", "#b0b8d5", "#f1a6a8", "#c9e2a9"],
  CHART_BASIC_ALTERNATE: ["#1db03f", "#ff6e41", "#f32a4d", "#343fbb"],
  CHART_BASIC_STROKES_ALTERNATE: ["#bbe7c5", "#ffd3c6", "#fbbfc9", "#c2c5ea"],
  CHART_ADVANCED: [
    "#ccaaff",
    "#aab7ff",
    "#73a4ff",
    "#f38498",
    "#ffa774",
    "#fff1a7",
    "#b4ffc1",
    "#8dd8b6",
    "#fdc79a",
    "#ccadea",
    "#b08ff0",
    "#fff07d",
    "#9bfff7",
    "#8cb6f9",
    "#e882ae",
  ],
  CHART_ADVANCED_ALTERNATIVE: [
    "#27272F",
    "#f11c3a",
    "#ccaaff",
    "#aab7ff",
    "#73a4ff",
    "#f38498",
    "#ffa774",
    "#fff1a7",
    "#b4ffc1",
    "#8dd8b6",
    "#fdc79a",
    "#ccadea",
    "#b08ff0",
    "#fff07d",
    "#9bfff7",
    "#8cb6f9",
    "#e882ae",
  ],
  CHART_AXIS: "#E2E7EE",
  CHART_DATALABELS: "#304758",
  RAINBOW: [
    "#f80c12",
    "#ee1100",
    "#ff3311",
    "#73228d",
    "#a12ec7",
    "#CC33FF",
    "#ff4422",
    "#ff6644",
    "#ff9933",
    "#feae2d",
    "#ccbb33",
    "#d0c310",
    "#aacc22",
    "#69d025",
    "#22ccaa",
    "#12bdb9",
    "#11aabb",
    "#4444dd",
    "#3311bb",
    "#3b0cbd",
    "#442299",
    "#312e2e",
    "#433333",
    "#432626",
  ],
};

export const CSS_COLOR_VARIABLES = {
  "--rowBorderColor": COLORS.ROW_BORDER,
  "--DataGrid-containerBackground": COLORS.TEXT_WHITE,
  "--rowAccentBackground": COLORS.SURFACE_ACCENT_ROW,
  "--rowAccentHoverBackground": COLORS.SURFACE_ACCENT_ROW_HOVER,
} as const;
